"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const CardRow = ({ title, value, titleBold = false, }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex space-between", children: [(0, jsx_runtime_1.jsxs)("span", { className: `${titleBold ? 'text-bold' : ''}`, children: [title ?? '', ":"] }), (0, jsx_runtime_1.jsx)("span", { children: value ?? '---' })] }));
};
exports.default = CardRow;
